import { render, staticRenderFns } from "./ProductGalerie.vue?vue&type=template&id=c5be877a&scoped=true&"
import script from "./ProductGalerie.vue?vue&type=script&lang=js&"
export * from "./ProductGalerie.vue?vue&type=script&lang=js&"
import style0 from "./ProductGalerie.vue?vue&type=style&index=0&id=c5be877a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5be877a",
  null
  
)

export default component.exports